// DEPENDENCIES
import React  from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import { TopBarContainer } from './Components/Main/TopBar';
import TopBarClean from './Components/Main/TopBarClean';
import Header from './Components/Main/Header';
import { SideBar } from './Components/ScreenElements/SideBar';
import { WrapperSideMenu } from './Components/Wrappers';
import { browserHistory } from 'react-router';


// INNER IMPORTS
import './App.css';
import { TempUserButton } from "./Components/Modals/TempUserButton";
import { TopBarUserMessage } from "./Components/Modals/TopBarUserMessage";
import { isMobile } from "./utils";
import { MobileSideMenu } from "./Components/ScreenElements/MobileSideMenu";
import { UserPanelBanner } from "./Components/ScreenElements/Banners";

const App = props => {

    const setLayout = () => {

        // main, user panel and packages
        if (props.route.structType === 1) {
            return (
                <div className="App-content rtl">
                    <TopBarUserMessage />

                    <TopBarContainer/>
                    {props.location.pathname.includes('user-panel')
                        ? <UserPanelBanner/>
                        : <Header location={props.location} />
                    }
                    <TempUserButton />

                    {props.children}
                </div>
            )
        }

        // restore password
        if (props.route.structType === 2) {
            return (
                <div className="App-content rtl">
                    <TopBarClean/>
                    {props.children}
                </div>
            )
        }

        // admin
        if (props.route.structType === 3) {
            const storedState = JSON.parse(localStorage && localStorage.getItem('mu_st'));
            if (!storedState || !storedState.users || !storedState.users.token) return browserHistory.replace('/');
            const payload = JSON.parse(atob((storedState.users.token || '').split('.')[1]));
            if (payload.role !== 'admin') {
                browserHistory.replace('/');
                return null
            }

            document.body.style.overflow = 'initial';

            return (
                <div className="App-content">
                    <SideBar />
                    <WrapperSideMenu>
                        {props.children}
                    </WrapperSideMenu>
                </div>
            )
        }
    };

    // should have some kind of a default 404 'got lost' page
    return (
        <div className="App">
            {isMobile() && props.route.structType === 1 ? <MobileSideMenu /> : null}
            {setLayout()}
        </div>
    );
}

App.propTypes = {
    children: PropTypes.element,
    route: PropTypes.object,
    location: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js